import loadImage from 'blueimp-load-image'

const imageToBase64 = (image, opts) =>
  new Promise((resolve, reject) => {
    const normalizedImageReader = loadImage(
      image,
      (img, meta) => {
        if (!img) {
          reject(new Error('Error loading image'))
          return
        }

        resolve({ base64: img.toDataURL('image/jpeg'), meta })
      },
      {
        ...opts,
        orientation: true,
        meta: true,
        canvas: true,
      }
    )

    normalizedImageReader.onerror = () => {
      reject(normalizedImageReader.error)
    }
  })

export default imageToBase64
